var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex"},[_c('imgWithNoImageError',{class:'img-list-thumbnail',attrs:{"src":_vm.src,"height":"30px","width":"30px","hover":false}}),_c('span',{staticClass:"title align-self-center ml-2"},[_vm._v(_vm._s(_vm.title))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }